import * as React from 'react';
import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {getMaterialDetails} from "../../redux/material/actions";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    FormControlLabel,
    Grid,
    Modal,
    Radio,
    Typography
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ReceiptIcon from "@mui/icons-material/Receipt";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import {callMaterialSwap, cleanApiResponse} from "../../redux/dynamo_db/actions";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import {extractUserInfoFromToken, getLocalStorageSAMLToken} from "../../utils";

export default function MaterialSwapSearch(props) {
    const [serialNumber, setSerialNumber] = useState('');
    const [tempSn, setTempSn] = useState('');
    const [result, setResult] = useState('');
    const [serialNumberCandidate, setSerialNumberCandidate] = useState([]);
    const [searchCalled, setSearchCalled] = useState(false);
    const dispatch = useDispatch();
    const [selectedSerialNumber, setSelectedSerialNumber] = useState(null);
    const [openConfirmModal, setOpenConfirmModal] = React.useState(false);
    const [openModal, setOpenModal] = React.useState(false);
    const localSerialNumber = props?.serialNumber;
    const handleSearch = () => {
        setSerialNumber(tempSn);
        const materialParams = {
            "serialNumber" : tempSn,
        };
        dispatch(getMaterialDetails(materialParams));
        setSearchCalled(true);
    };
    const handleSelection = (serialNumber) => {
        if (selectedSerialNumber === serialNumber) {
            setSelectedSerialNumber(null);
        } else {
            setSelectedSerialNumber(serialNumber);
        }
    };
    const _apiResponse = useSelector(state => state.apiResponse?.source === "CALL_MATERIAL_SWAP" ? state.apiResponse.message : null);

    const searchMaterial = useSelector(state => {
        return state?.materials?.find(m => m.serial_number === serialNumber);
    });
    const handleMaterialSwap = () => {
        const saml_token = getLocalStorageSAMLToken();
        const infoToken = extractUserInfoFromToken(saml_token);
        const materialSwapSns = {
            "serial_number": localSerialNumber,
            "new_serial_number": selectedSerialNumber,
            "request_user": infoToken.username
        };
        dispatch(callMaterialSwap(materialSwapSns));
    };

    const checkHwsSwap = () => {
        if (selectedSerialNumber === null) {
            setOpenModal(true);
        } else {
            setOpenConfirmModal(true);
        }
    };
    useEffect(() => {
        if (searchMaterial) {
            setSerialNumberCandidate(prev => {
                const newItem = {
                    "serial_number": searchMaterial?.serial_number,
                    "order_id": searchMaterial?.order?.order_id,
                    "order_line": searchMaterial?.order?.order_line,
                    "part_number": searchMaterial?.part_number,
                    "applicant_id": searchMaterial?.sold_to?.applicant_id,
                    "business_partner": searchMaterial?.business_partner?.company_id,
                    "support_partner": searchMaterial?.support_partner?.company_id,
                    "end_customer": searchMaterial?.end_user?.company_id,
                };

                // Check if an item with the same serial_number already exists
                const existsIndex = prev.findIndex(item => item.serial_number === newItem.serial_number);

                if (existsIndex >= 0) {
                    const newArray = [...prev];
                    newArray[existsIndex] = newItem;
                    return newArray;
                } else {
                    return [...prev, newItem];
                }
            });
            setResult('Material added to the list.');
        } else {
            setResult('Material not found.');
        }
    }, [searchMaterial]);
    useEffect(() => {
        if (_apiResponse === 'Success' && searchCalled) {
            setSearchCalled(false)
            const materialParams = {
                "serialNumber" : localSerialNumber,
            };
            dispatch(getMaterialDetails(materialParams));
            dispatch(cleanApiResponse());
        }
    }, [_apiResponse, dispatch, searchCalled]);
    return (
     < React.Fragment>
         <div style={{width: '100%'}}>
             <Modal
              open={openConfirmModal}
              style={{
                  textAlign: "center",
                  paddingTop: "45vh"
              }}>
                 <>
                     <Typography
                      style={{color: 'white'}}
                     >
                         This will swap all entitlements and relationship from one serial number to the other, are you
                         sure you want to continue?
                     </Typography>
                     <div style={{paddingBottom: '1%'}}/>
                     <Grid container className='headercontainer'>
                         <Grid item>
                             <Button
                              style={{
                                  color: 'white',
                                  background: '#6b469e'
                              }}
                              onClick={() => {
                                  handleMaterialSwap();
                                  setOpenConfirmModal(false)
                              }}
                             >Yes</Button>
                         </Grid>
                         <Grid item style={{width: '7%'}}/>
                         <Grid item>
                             <Button
                              style={{
                                  color: 'white',
                                  background: '#6b469e'
                              }}
                              onClick={() => setOpenConfirmModal(false)}
                             >No</Button>
                         </Grid>
                     </Grid>
                 </>
             </Modal>
             <Modal
              open={openModal}
              style={{
                  textAlign: "center",
                  paddingTop: "45vh"
              }}>
                 <>
                     <Typography
                      style={{color: 'white'}}
                     >
                         One serial number MUST be selected.
                     </Typography>
                     <div style={{paddingBottom: '1%'}}/>
                     <Grid container className='headercontainer'>
                         <Grid item>
                             <Button
                              style={{
                                  color: 'white',
                                  background: '#6b469e'
                              }}
                              onClick={() => setOpenModal(false)}
                             >Ok</Button>
                         </Grid>
                     </Grid>
                 </>
             </Modal>
             <TableContainer component={Paper}>
                 <Accordion
                  defaultExpanded={true}
                 >
                     <AccordionSummary
                      style={{
                          backgroundColor: "#6b469e",
                          color: "white",
                          height: '3vh'
                      }}
                      sx={{
                          "&.Mui-expanded": {
                              minHeight: 0
                          },
                          "&.MuiAccordionSummary-root": {
                              minHeight: 0
                          },
                      }}
                      expandIcon={<ExpandMoreIcon style={{color: 'white'}}/>}
                     >
                         <Typography
                          style={{
                              width: '100%'
                          }}
                         >
                             <ReceiptIcon style={{marginRight: '1%', verticalAlign: "middle"}}/>
                             Replacement candidate
                         </Typography>
                     </AccordionSummary>
                     <AccordionDetails>
                         <TextField id="outlined-basic" label="Enter serial number" variant="outlined"
                                    onChange={(e) => setTempSn(e.target.value)}
                                    style={{
                                        flex: 8.5,
                                        height: '5%'
                                    }}
                                    value={tempSn}
                         />
                         <Grid item>
                             <Button variant="contained" onClick={handleSearch} style={{width: '15vw'}}>Search</Button>
                         </Grid>
                         {searchCalled && (
                          <div style={{marginTop: '20px', textAlign: 'center'}}>
                              <Typography variant="h6">{result}</Typography>
                          </div>
                         )}
                     </AccordionDetails>
                 </Accordion>
                 <Accordion defaultExpanded={true}>
                     <AccordionSummary
                      style={{
                          backgroundColor: "#6b469e",
                          color: "white",
                          height: '3vh'
                      }}
                      sx={{
                          "&.Mui-expanded": {
                              minHeight: 0
                          },
                          "&.MuiAccordionSummary-root": {
                              minHeight: 0
                          },
                      }}
                      expandIcon={<ExpandMoreIcon style={{color: 'white'}}/>}
                     >
                         <Typography style={{width: '100%'}}>
                             <ReceiptIcon style={{marginRight: '1%', verticalAlign: "middle"}}/>
                             Replacement candidate serial numbers
                         </Typography>
                     </AccordionSummary>
                     <AccordionDetails>
                         <Table sx={{minWidth: '30%'}} size="small" aria-label="hws in sn data">
                             <TableHead>
                                 <TableRow>
                                     <TableCell>
                                         Select
                                     </TableCell>
                                     <TableCell>
                                         Serial Number
                                     </TableCell>
                                     <TableCell>
                                         Order Id
                                     </TableCell>
                                     <TableCell>
                                         Order Line
                                     </TableCell>
                                     <TableCell>
                                         Part Number
                                     </TableCell>
                                     <TableCell>
                                         Applicant Id
                                     </TableCell>
                                     <TableCell>
                                         Business Partner CRD Id
                                     </TableCell>
                                     <TableCell>
                                         Support Partner CRD Id
                                     </TableCell>
                                     <TableCell>
                                         End Customer Id
                                     </TableCell>
                                 </TableRow>
                             </TableHead>
                             <TableBody>
                                 {serialNumberCandidate.map((row) => (
                                  <React.Fragment
                                   key={row?.hws_sns_trail_identifier}
                                  >
                                      <TableRow>
                                          <TableCell align="center">
                                              <FormControlLabel
                                               control={
                                                   <Radio
                                                    checked={selectedSerialNumber === row?.serial_number}
                                                    onClick={() => handleSelection(row?.serial_number)}
                                                    value={row?.serial_number}
                                                   />
                                               }
                                               label=""
                                              />
                                          </TableCell>
                                          <TableCell>{row?.serial_number}</TableCell>
                                          <TableCell>{row?.order_id}</TableCell>
                                          <TableCell>{row?.order_line}</TableCell>
                                          <TableCell>{row?.part_number}</TableCell>
                                          <TableCell>{row?.applicant_id}</TableCell>
                                          <TableCell>{row?.business_partner}</TableCell>
                                          <TableCell>{row?.support_partner}</TableCell>
                                          <TableCell>{row?.end_customer}</TableCell>
                                      </TableRow>

                                  </React.Fragment>
                                 ))}
                             </TableBody>

                         </Table>
                     </AccordionDetails>
                 </Accordion>
             </TableContainer>
             <Grid
              container
              style={{
                  justifyContent: 'center'
              }}
             >
                 <Grid item>
                     <Button variant="contained" onClick={checkHwsSwap} style={{width: '15vw'}}>Swap</Button>
                 </Grid>
             </Grid>
             {_apiResponse && _apiResponse !== 'Success' && (
              <div style={{marginTop: '20px', textAlign: 'center'}}>
                  <Typography variant="h6">Swap Result: {_apiResponse}</Typography>
              </div>
             )}
         </div>
     </React.Fragment>
    );
};

